import * as React from "react";
import { forwardRef } from "react";
const SvgArrowLeft = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.9064 17.0155L12.4356 16.4839L8.31061 12.3763H16.9722V11.6249H8.30592L12.3995 7.51579L11.868 6.98657L7.13733 11.735C7.10246 11.7698 7.0748 11.8112 7.05593 11.8567C7.03706 11.9022 7.02734 11.951 7.02734 12.0003C7.02734 12.0496 7.03706 12.0984 7.05593 12.1439C7.0748 12.1894 7.10246 12.2308 7.13733 12.2656L11.9064 17.0155Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
